export default __webpack_public_path__ + "static/ayo-c9006c711157bcfb40d0ab0e7a8769f9.jpg";